export default __webpack_public_path__ + "static/media/confluence-long.fe542582.svg";